import React, {useState} from "react";
import {Col, Row, Button} from "react-bootstrap";

import {InputWithLabel} from "../../component/Form/InputWithLabel";
import BizLocationSelector from "../../component/BizLocation/BizLocationSelector";
import ReadpointSelector from "../../readpoint/component/ReadpointSelector";
import Notify from "../../services/Notify";
import ModalMessageNew from "../../component/Modal/ModalMessageNew";
import CheckpointService from "../../checkpoint/CheckpointService";

class GridCheckpoints {

    title = 'Lista de Pontos de Controle';
    actionsButtons = (row, reloadGrid) => {
        const [show, setShow] = useState(false);
        const checkpointService = new CheckpointService()
        const deleteItem = async () => {
            try {
                await checkpointService.deleteCheckpointPointById(row.original.id);
                Notify.success('Ponto de controle deletado com sucesso!');
            } catch (error) {
                Notify.error('Erro ao excluir Ponto de Controle', error);
            } finally {
                setShow(false);
                reloadGrid && reloadGrid();
            }
        };
        return (
            <Row>
                <Col sm={4} style={{marginBottom: '3px'}}>
                    <Button bsStyle="info" href={"#/checkpoints/" + row.original.id + "/profiles"} block>Perfil
                        de Acesso</Button>
                </Col>
                <Col sm={4} style={{marginBottom: '3px'}}>
                    <Button bsStyle="primary" href={"#/checkpoints/" + row.original.id + "/readpoints"}
                            block>Pontos de Leituras</Button>
                </Col>
                <Col sm={4} style={{marginBottom: '3px'}}>
                    <Button bsStyle="success" href={"#/checkpoints/" + row.original.id + "/edit"}
                            block>Editar</Button>
                </Col>
                <Col sm={4} style={{marginBottom: '3px'}}>
                    <Button bsStyle="danger" block onClick={() => setShow(true)}>Excluir</Button>
                </Col>
                <ModalMessageNew
                    row={row}
                    showModal={show}
                    handleShowModal={setShow}
                    title="Tem certeza que deseja excluir o ponto de leitura?"
                    successButtonAction={deleteItem}
                />
            </Row>
        );
    };
    exportNewPage = true;
    showPdfButton = false;

    columns = [
        {
            width: 250,
            Header: "Nome",
            accessor: "friendlyName",
            HeaderColumn: true
        },
        {
            width: 250,
            Header: "Local/Destino",
            accessor: "type",
            Cell: row => (
                <div>
                    <p style={{marginLeft: '2rem'}}>
                        {row.original.lsd && row.original.lsd.bizLocation && row.original.lsd.bizLocation.friendlyName}
                    </p>
                </div>
            )
        },
        {
            width: 175,
            Header: "Tipo",
            accessor:
                "type",
            Cell:
                row => (<p>{row.original.type === 'DEFAULT' ? 'Padrão' : 'Comissionador'}</p>)
        }
        ,
        {
            Header: "Opções",
            sortable:
                false,
            filterable:
                false,
            export:
                false,
            Cell:
                row => this.actionsButtons(row, this.forceReload)
        }
    ];

    customFilters = {friendlyName: null}

    customFilterComponent = (props, state, onChange) => {
        return (
            <Row>
                <Col md={4}>
                    <InputWithLabel label="Nome" onChangeWithDelay={e => {
                        this.customFilters.friendlyName = e.trim()
                        onChange(this.customFilters)
                    }}/>
                </Col>
                <Col md={4}>
                    <BizLocationSelector
                        onChange={e => {
                            this.customFilters.bizLocation = e && e.id;
                            onChange(this.customFilters);
                        }}
                    />
                </Col>
                <Col md={4}>
                    <ReadpointSelector
                        onChange={e => {
                            this.customFilters.readpoint = e && e.id;
                            onChange(this.customFilters);
                        }}
                    />
                </Col>
            </Row>
        )
    }

    endpoint = () => {
        const params = new URLSearchParams({})
        const {friendlyName, readpoint, bizLocation} = this.customFilters

        friendlyName && params.append('friendlyName', friendlyName)
        bizLocation && params.append('_bizLocationId', bizLocation)
        readpoint && params.append('_readpointId', readpoint)

        return `ton/v1/checkpoints?${params.toString()}`
    }
}

export default GridCheckpoints;



// WEBPACK FOOTER //
// ./src/customGrid/entities/Checkpoints.js